<template>
  <div>
    <navigation></navigation>

    <div class="container px-4 mx-auto">
      <h1 class="mb-5">Settings</h1>

      <h2 class="mb-3">Account</h2>
      <form
        class="mb-10"
        data-cy="update-account-form"
        v-if="user"
        v-on:submit.prevent="updateAccount"
      >
        <div class="mb-3">
          <label class="font-bold block mb-1" for="name-input">Name</label>
          <input
            class="input-text-1 mb-3"
            data-cy="name-input"
            id="name-input"
            placeholder="name"
            type="text"
            v-model="user.name"
          />
        </div>
        <div class="mb-3">
          <label class="font-bold block mb-1" for="email-input">Email</label>
          <input
            class="input-text-1 mb-3"
            data-cy="email-input"
            id="email-input"
            placeholder="email"
            type="text"
            v-model="user.email"
          />
        </div>

        <div class="mb-3">
          <input
            data-cy="change-password"
            id="change-password"
            type="checkbox"
            v-model="user.changePassword"
          />
          <label class="font-bold cursor-pointer" for="change-password"
            >Update Password</label
          >
        </div>

        <div v-if="user.changePassword">
          <div class="mb-3">
            <label class="font-bold block mb-1" for="password-input"
              >Password</label
            >
            <input
              class="input-text-1 mb-3"
              data-cy="password-input"
              id="password-input"
              placeholder="current password"
              type="password"
              v-model="user.password"
            />
          </div>

          <div class="mb-3">
            <label class="font-bold block mb-1" for="new-password-input"
              >New Password</label
            >
            <input
              class="input-text-1 mb-3"
              data-cy="new-password-input"
              id="new-password-input"
              placeholder="new password"
              type="password"
              v-model="user.newPassword"
            />
          </div>

          <div class="mb-3">
            <label class="font-bold block mb-1" for="confirm-new-password-input"
              >Confirm New Password</label
            >
            <input
              class="input-text-1 mb-3"
              data-cy="confirm-new-password-input"
              id="confirm-new-password-input"
              placeholder="confirm new password"
              type="password"
              v-model="user.confirmNewPassword"
            />
          </div>
        </div>
        <input
          class="button-1"
          data-cy="update-settings-button"
          type="submit"
          value="Update"
        />
      </form>

      <h2 class="mb-3">Notebooks</h2>
      <form class="mb-20" v-if="books" v-on:submit.prevent="updateSettings">
        <label class="mb-1 block" for="default-book">Default Notebook</label>
        <v-select
          :onChange="selected"
          :options="books"
          :value="defaultBook"
          class="mb-3"
          id="default-book"
          label="title"
          placeholder="Default notebook"
        ></v-select>

        <input
          class="button-1"
          data-cy="update-settings-button"
          type="submit"
          value="Save"
        />
      </form>
    </div>
  </div>
</template>
<script>
import { API_URL } from "../../env";
import Navigation from "../Navigation.vue";
import vSelect from "vue-select";
import axios from 'axios';

export default {
  data() {
    return {
      userData: {},
      showChangePassword: false
    };
  },
  components: {
    Navigation,
    "v-select": vSelect
  },
  created() {
    this.$store.dispatch("aGetSettings");
  },
  methods: {
    updateSettings() {
      this.$loading(true);
      let data = {
        defaultBook: this.defaultBook
      };
      let uri = `${API_URL}/admin/settings`;
      axios
        .post(uri, data, this.$store.getters.authHeaders)
        .then(response => {
          const config = {
            status: "success",
            message: "Your settings were updated.",
            time: 3000
          };
          this.flashMessage.show(config);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    async updateAccount() {
      this.$loading(true);
      try {
        const res = await this.$store.dispatch("aUpdateUserAccount", {
          user: this.user
        });
        const config = {
          status: "success",
          message: "Your settings were updated.",
          time: 3000
        };
        this.flashMessage.show(config);
      } catch (e) {
        let errorMessage = e.response.data.message;
        this.$store.dispatch("populateErrors", errorMessage);
      }
      this.$loading(false);
    },
    selected(option) {
      this.$store.dispatch("aSetDefaultBook", option);
    }
  },
  computed: {
    books() {
      return this.$store.state.notes.books;
    },
    defaultBook() {
      return this.$store.state.notes.defaultBook;
    },
    user() {
      return this.$store.state.notes.user;
    }
  }
};
</script>
